// @flow
import React from 'react';
import {connect} from 'react-redux';
import {NavLink} from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import styles from './Menu.styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

type Props = {
  classes: any,
  menuList: Array<any>,
  navigation: any
};

class Menu extends React.Component<Props> {
    render() {
        const { classes } = this.props;
        return (
          <Hidden smDown>
            <div className={classes.menu}>
              <Tabs
                value={false}
                onChange={this.handleChange}
                variant="scrollable"
                scrollButtons="auto"
                indicatorColor="primary"
                textColor="primary"
                classes={{
                  root: classes.tabs,
                  scroller: classes.tabsScroller,
                  flexContainer: classes.tabsContainer,
                  scrollButtonsAuto: classes.scrollButtonsAuto
                }}
              >
                {this.props.menuList.map(menuItem => {
                    const isActive = () => {
                      return (
                        this.props.navigation.category.slug === menuItem.term.slug
                      );
                    };
                    return (
                      <Tab
                        key={menuItem.term_id}
                        classes={{
                          root: classes.item,
                          label: classes.itemLabel,
                          labelContainer: classes.itemLabelContainer
                        }}
                        component={NavLink}
                        className={classes[`style_${menuItem.term_id}`]}
                        to={`/category/${menuItem.term.slug}`}
                        isActive={isActive}
                        label={menuItem.term.name}
                      />
                    );
                  })
                }
              </Tabs>
            </div>
          </Hidden>
        );
    }
}

const mapStateToProps = state => ({
  menuList: state.menu,
  navigation: state.navigation
});

const styledComponent = withStyles(styles, {withTheme: true})(Menu);
const Component = connect(mapStateToProps)(styledComponent);
export {Component as Menu};
export default Component;